import { render } from "./CarouselCom.vue?vue&type=template&id=79b39c08&scoped=true"
import script from "./CarouselCom.vue?vue&type=script&lang=js"
export * from "./CarouselCom.vue?vue&type=script&lang=js"

import "./CarouselCom.vue?vue&type=style&index=0&id=79b39c08&scoped=true&lang=less"

import exportComponent from "D:\\Jhy\\点甜官网\\2026最新版官网\\officialwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b39c08"]])

export default __exports__